export const filterRegranulaty = () => {
  const form = document.querySelector(".js-products-filter");
  const countEl = document.querySelector(".js-products-count");
  const filterWrapper = document.querySelector(".filter__wrapper");

  if (!form) return;

  const ajaxUrl = window.ajaxurl || '/wp-admin/admin-ajax.php';

  const getResults = () => document.querySelector(".js-products-results");

  const updateCount = () => {
    const results = getResults();
    const count = results?.dataset.productsCount || 0;

    if (countEl) {
      countEl.textContent = `(${count})`;
    }
  };

  const buildFormData = () => {
    const formData = new FormData();

    formData.append("action", "filter_regranulat");

    const inputs = form.querySelectorAll('input[type="checkbox"]:checked');

    inputs.forEach((input) => {
      formData.append(input.name, input.value);
    });

    return formData;
  };

  const fetchProducts = async () => {
    const currentResults = getResults();

    if (currentResults) {
      currentResults.classList.add("is-loading");
    }

    try {
      const response = await fetch(ajaxUrl, {
        method: "POST",
        body: buildFormData(),
      });

      const data = await response.text();
      const freshResults = getResults();

      if (freshResults && freshResults.parentNode) {
        freshResults.outerHTML = data;
      }

      updateCount();
    } catch (error) {
      console.error("Filter error:", error);
    }
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    fetchProducts();
    if(filterWrapper){
      filterWrapper.classList.remove('filter__wrapper--mobile-visible');
    }
  });




  updateCount();
};
